<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Letter Content</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="lc.messageCode"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="lc.message"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Certified By"
              :class="classPadding"
              v-model="lc.certifiedBy"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Position"
              :class="classPadding"
              v-model="lc.certifiedPos"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>

      <router-view />
    </v-container>
  </div>
</template>
<script>
import List from "./List";
import userAccessMixin from "../../../../mixins/userAccessMixin";
import { encyrptText } from "../../../../helpers/user";
const API_ENDPOINT = "/api/letterContent";
export default {
  metaInfo: {
    title: "Letter Content",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    reloadComp: true,
    componentKey: 0,
    lc: {},
    isSaving: false,
  }),
  components: {
    List,
  },
  methods: {
    save() {
      this.isSaving = true;
      var newModel = {
        messageCode: this.lc.messageCode,
        message: this.lc.message,
        certifiedBy: encyrptText(this.lc.certifiedBy),
        certifiedPos: encyrptText(this.lc.certifiedPos),
      };
      this.$axios
        .post(`${API_ENDPOINT}`, newModel)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.$router.push(`/letter-content/edit/${item.messageCode}`);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.messageCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.errro(response.data.message);
            });
        }
      });
    },
    reset() {
      this.lc = {};
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
  watch: {
    $route(val) {
      if (val.name === "letter-content") {
        this.forceRerender();
      }
    },
  },
  created() {
    this.getUserAccessRights("Message");
  },
};
</script>
